import { render, staticRenderFns } from "./ForgetPwdDialog.vue?vue&type=template&id=eebb2b2e&scoped=true"
import script from "./ForgetPwdDialog.vue?vue&type=script&lang=js"
export * from "./ForgetPwdDialog.vue?vue&type=script&lang=js"
import style0 from "./ForgetPwdDialog.vue?vue&type=style&index=0&id=eebb2b2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eebb2b2e",
  null
  
)

export default component.exports